import React from 'react';
import { TopBar } from './TopBar';
import { FooterBar } from './FooterBar';
import { BannerCard } from './BannerCard';
const CARDS_DATA = [{
  title: 'Motor de Riqueza',
  subtitle: 'Tu negocio funcionando en 48hs',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/2XJkSkPxGwSYiqnhv4APtd/Banner_1.png',
  imageAlt: 'Banner de Motor de Riqueza con escritorio oscuro',
  link: 'https://nivel1.wealthenginearg.com/'
}, {
  title: 'Wealth Engine',
  subtitle: 'Sistema Completo de Productos Digitales con IA',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/41221SXYd9sUorG6PMxq9X/Banner_2.png',
  imageAlt: 'Banner de Wealth Engine Sistema Completo con monitores',
  comingSoon: true
}, {
  title: 'Wealth Engine Partners',
  subtitle: 'La comunidad elite que te lleva al siguiente nivel',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/pQ6tyrMV83FNcqsWuByGyg/Banner_3.png',
  imageAlt: 'Banner de Wealth Engine Partners con interior de lujo',
  comingSoon: true
}];
export const LandingPage = () => {
  return <main className="min-h-screen w-full bg-we-bg relative flex flex-col items-center overflow-x-hidden selection:bg-we-gold/30" data-id="element-14">
      {/* Background Watermark Logo */}
      <div className="fixed inset-0 flex items-center justify-center pointer-events-none z-0 overflow-hidden" data-id="element-15">
        <img src="https://cdn.magicpatterns.com/uploads/sVQ6gAmubiRaCE4dGkA8NY/Logo_Wealth_Engine.jpg" alt="" className="w-[600px] md:w-[800px] opacity-[0.12] mix-blend-screen object-contain" aria-hidden="true" data-id="element-16" />
      </div>

      <div className="w-full max-w-[640px] flex flex-col items-center px-4 md:px-6 relative z-10" data-id="element-17">
        <TopBar data-id="element-18" />

        <section className="w-full flex flex-col gap-10 py-6" data-id="element-19">
          {CARDS_DATA.map((card, index) => <BannerCard key={index} title={card.title} subtitle={card.subtitle} imageUrl={card.imageUrl} imageAlt={card.imageAlt} link={card.link} comingSoon={card.comingSoon} delay={0.1 + index * 0.15} data-id="element-20" />)}
        </section>

        <FooterBar data-id="element-21" />
      </div>
    </main>;
};